export default __webpack_public_path__ + "static/media/AutoGravity-2.b76073dc.jpg";